const faqs = [
  {
    question: "Dans quel délai intervenez-vous à Saverne ?",
    answer:
      "Saverne se trouve à une quarantaine de minutes de notre atelier. Pour une urgence, nous intervenons en 24 heures. Pour une réparation planifiée, comptez 24 à 48 heures. Le déplacement est gratuit dans tout le Bas-Rhin, et le technicien vous appelle avant de partir pour vous donner un créneau précis.",
  },
  {
    question: "Y a-t-il des frais de déplacement depuis Saverne ?",
    answer:
      "Non, le déplacement est entièrement gratuit. Notre zone couvre tout le Bas-Rhin, et Saverne en fait partie. Le technicien arrive avec son stock de pièces, diagnostique gratuitement et vous remet un devis. Vous ne payez que l'intervention réalisée, et seulement si vous acceptez le devis.",
  },
  {
    question: "Réparez-vous les fenêtres anciennes de Saverne ?",
    answer:
      "Oui, absolument. Saverne compte de nombreuses belles demeures avec des fenêtres en bois anciennes. Nous réparons tous les types de fenêtres : bois, PVC, aluminium. Nos techniciens emportent les pièces adaptées et peuvent commander rapidement les modèles spécifiques. Toutes les marques sont prises en charge, et chaque pièce remplacée est garantie 10 ans.",
  },
];

export default function FAQ() {
  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-[1280px] mx-auto">
        <h2 className="font-serif text-2xl md:text-3xl font-bold text-plum-dark mb-10">
          Questions fréquentes — Saverne
        </h2>
        <div className="space-y-4 max-w-3xl">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl border border-rose-100 p-5 md:p-6"
            >
              <h3 className="font-serif text-base md:text-lg font-semibold text-plum-dark mb-3">
                {faq.question}
              </h3>
              <p className="text-plum-dark text-sm md:text-base leading-relaxed">
                {faq.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}